module.exports = __webpack_public_path__ + "static/media/fastcashhomes.3284a2f8.jpg";